import _export from '../internals/export.js';
import stringPad from '../internals/string-pad.js';
import stringPadWebkitBug from '../internals/string-pad-webkit-bug.js';

var $ = _export;
var $padEnd = stringPad.end;
var WEBKIT_BUG = stringPadWebkitBug; // `String.prototype.padEnd` method
// https://tc39.es/ecma262/#sec-string.prototype.padend

$({
  target: 'String',
  proto: true,
  forced: WEBKIT_BUG
}, {
  padEnd: function padEnd(maxLength
  /* , fillString = ' ' */
  ) {
    return $padEnd(this, maxLength, arguments.length > 1 ? arguments[1] : undefined);
  }
});
